import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EcommerceHeader from "../components/EcommerceHeader";
import { CartIcon } from "../components/EcommerceIcons";
import { EcommerceFooter } from "./EcommerceHome";
import { readCart, saveCart } from "../utils/ecommerceStorage";
import "../css/Ecommerce.css";

export default function EcommerceCart() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    setCartItems(readCart());
  }, []);

  const persistCart = (items) => {
    setCartItems(items);
    saveCart(items);
  };

  const updateQuantity = (productId, quantity) => {
    persistCart(
      quantity <= 0
        ? cartItems.filter((item) => item.product.id !== productId)
        : cartItems.map((item) => (item.product.id === productId ? { ...item, quantity } : item))
    );
  };

  const removeItem = (productId) => {
    persistCart(cartItems.filter((item) => item.product.id !== productId));
  };

  const totalPrice = cartItems.reduce((sum, item) => sum + item.product.price * item.quantity, 0);

  return (
    <div className="ecomm-app-screen">
      <EcommerceHeader />

      <main className="ecomm-cart-page">
        <h1>Your Cart</h1>

        {cartItems.length === 0 ? (
          <section className="ecomm-cart-page-empty">
            <CartIcon />
            <h2>Your cart is empty</h2>
            <p>Add books to start shopping</p>
            <button onClick={() => navigate("/home")}>Browse Books</button>
          </section>
        ) : (
          <>
            <div className="ecomm-cart-page-list">
              {cartItems.map((item) => (
                <article className="ecomm-cart-page-item" key={item.product.id}>
                  <div className="ecomm-cart-product">
                    <img src={item.product.image} alt={item.product.title} />
                    <div>
                      <h3>{item.product.title}</h3>
                      <p>₹{item.product.price} each</p>
                      <button onClick={() => removeItem(item.product.id)}>Remove</button>
                    </div>
                  </div>

                  <div className="ecomm-cart-page-side">
                    <div className="ecomm-qty small">
                      <button onClick={() => updateQuantity(item.product.id, item.quantity - 1)}>-</button>
                      <span>{item.quantity}</span>
                      <button onClick={() => updateQuantity(item.product.id, item.quantity + 1)}>+</button>
                    </div>
                    <strong>₹{item.product.price * item.quantity}</strong>
                  </div>
                </article>
              ))}
            </div>

            <section className="ecomm-cart-total">
              <div>
                <span>Total Amount:</span>
                <strong>₹{totalPrice}</strong>
              </div>
              <button onClick={() => navigate("/checkout")}>Proceed to Checkout</button>
              <button className="secondary" onClick={() => navigate("/home")}>Continue Shopping</button>
            </section>
          </>
        )}
      </main>

      <EcommerceFooter active="cart" />
    </div>
  );
}
